import { useEffect } from "react";
import { Outlet } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { postRefresh } from "../actions";
import { authSelector } from "../reducers";
import { getIntegrations } from "../actions/organization/activeintegrations";

import AlertGlobal from "../common/alertglobal";
import LoadingGlobal from "../common/loaders/loadingglobal";
import { GlobalStyles } from "../common/globalstyles";

import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import {
  AllEnterpriseModule,
  ModuleRegistry,
  provideGlobalGridOptions,
  ClientSideRowModelModule,
  CsvExportModule,
} from "ag-grid-enterprise";

// Register AG Grid modules once
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  AllEnterpriseModule.with(AgChartsEnterpriseModule),
  CsvExportModule,
]);
provideGlobalGridOptions({ theme: "legacy" });

/**
 * RootLayout - The top-level layout component
 * Handles global state, authentication refresh, and global UI components
 */
export const RootLayout = () => {
  const dispatch = useDispatch();
  const auth = useSelector(authSelector);

  // Refresh token on mount
  useEffect(() => {
    const refreshToken = sessionStorage.getItem("esalary-refresh");
    if (auth === null && refreshToken !== null) {
      dispatch(postRefresh(refreshToken));
    }
  }, [dispatch, auth]);

  // Initialize integrations when authenticated
  useEffect(() => {
    if (auth !== null && !auth.mfaRequired) {
      if (auth.companyBusinessId) {
        dispatch(getIntegrations(auth.companyBusinessId));
      } else {
        console.error("companyBusinessId null for", auth.companyNumber);
      }

      // Initialize Pendo analytics
      const { pendo } = window;
      if (pendo !== undefined) {
        pendo.initialize({
          visitor: {
            id: auth.user_name,
            role: auth.role,
            employeeNumber: Number(auth.employeeNumber),
            companyName: auth.companyName,
            companyNumber: Number(auth.companyNumber),
          },
          account: {
            id: location.hostname,
          },
        });
      }
    }
  }, [auth, dispatch]);

  return (
    <>
      <AlertGlobal />
      <LoadingGlobal />
      <GlobalStyles />
      <Outlet />
    </>
  );
};
